import { COUNTRIES } from "@/lib/countries";

export const inputClass =
  "fa-field w-full rounded-xl border border-fg/10 bg-[#1A1A1A] px-4 py-3 text-[15px] text-fg placeholder:text-fg/30 [color-scheme:dark]";

export const describe = (id, error, hint) =>
  ({ id, "aria-invalid": error ? true : undefined, "aria-describedby": [hint && `${id}-hint`, error && `${id}-error`].filter(Boolean).join(" ") || undefined });

export const Field = ({ id, label, required, error, hint, children }) => (
  <div>
    <label htmlFor={id} className="block text-[13px] text-fg">
      {label}
      {required ? <span className="text-subtle"> *</span> : <span className="text-subtle"> (optional)</span>}
    </label>
    <div className="mt-2">{children}</div>
    {hint && <p id={`${id}-hint`} className="mt-1.5 text-[12px] text-subtle">{hint}</p>}
    {error && <p id={`${id}-error`} className="mt-1.5 text-[13px] text-danger">{error}</p>}
  </div>
);

export const CountrySelect = ({ id, value, onChange, error, testId }) => (
  <select {...describe(id, error)} value={value} onChange={(e) => onChange(e.target.value)} data-testid={testId} className={inputClass}>
    <option value="">Select a country</option>
    {COUNTRIES.map((c) => <option key={c.code} value={c.code}>{c.name}</option>)}
  </select>
);

export const Check = ({ id, checked, onChange, children, error, testId }) => (
  <div>
    <label htmlFor={id} className="flex cursor-pointer items-start gap-3 text-[14px] leading-relaxed text-fg/85">
      <input id={id} type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} data-testid={testId}
        aria-invalid={error ? true : undefined} aria-describedby={error ? `${id}-error` : undefined}
        className="mt-1 h-4 w-4 shrink-0 accent-white" />
      <span>{children}</span>
    </label>
    {error && <p id={`${id}-error`} className="mt-1.5 pl-7 text-[13px] text-danger">{error}</p>}
  </div>
);

export const Honeypot = ({ value, onChange }) => (
  <div aria-hidden="true" className="absolute -left-[9999px] h-px w-px overflow-hidden">
    <label htmlFor="website">Website</label>
    <input id="website" name="website" tabIndex={-1} autoComplete="off" value={value} onChange={(e) => onChange(e.target.value)} />
  </div>
);

export const FormAlert = ({ message, testId }) =>
  message ? (
    <p role="alert" data-testid={testId} className="rounded-xl border border-fg/20 px-4 py-3 text-[14px] text-fg">{message}</p>
  ) : null;
